<div (click)="onMouseClick($event)">
  <router-outlet></router-outlet>
</div>
